import { Component, OnInit, OnDestroy, NO_ERRORS_SCHEMA } from '@angular/core';
import { MaintenanceService } from '../../services/maintenanceService';
import { SharedAuthService } from '../../../shared/shared.auth.service';
import { take } from 'rxjs/operators';
import { DropdownWithSearchComponent } from '../../../shared/elements/dropdown-with-search/dropdown-with-search.component';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { EnterpriseInitiativeRoleManagementComponent } from '../enterprise-initiative-role-management/enterprise-initiative-role-management.component';
import { EnterpriseInitiativeFieldManagementComponent } from '../enterprise-initiative-field-management/enterprise-initiative-field-management.component';
@Component({
    selector: 'app-enterprise-initiatives',
    templateUrl: './enterprise-initiatives.component.html',
    styleUrl: './enterprise-initiatives.component.css',
    imports: [DropdownWithSearchComponent, MatTabGroup, MatTab, EnterpriseInitiativeRoleManagementComponent, EnterpriseInitiativeFieldManagementComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class EnterpriseInitiativesComponent implements OnDestroy, OnInit {
  initiativeList: any = [];
  isUserAdmin: boolean = false;
  initiativeSubscription: any;
  fieldData:any = {};
  selectedInitiative:any;

  constructor(private maintenanceService: MaintenanceService, private sharedAuthService : SharedAuthService) {
    this.initiativeSubscription = this.maintenanceService.enabledInitiativeList.subscribe((data) => {
      this.initiativeList = data;
    });
  }

  ngOnInit() {
    if (!sessionStorage.getItem('techaccessData')) {
      this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
        this.checkAccess();
      });
    } else {
      this.checkAccess();
    }
  }
  checkAccess() {
    let isAdminRole = this.sharedAuthService.checkAdminSGAccess();
    let techAccessData = this.sharedAuthService.getTechAccessData();
    isAdminRole &&
    techAccessData &&
    techAccessData?.Role === 'Admin'
      ? (this.isUserAdmin = true)
      : (this.isUserAdmin = false);
    if(!this.maintenanceService.isEnabledInitiativesListSet) {
      this.maintenanceService.setEnabledInitiativesData();
    }
  }

  ngOnDestroy() {
    if (this.initiativeSubscription) {
      this.initiativeSubscription.unsubscribe();
    }
  }

  getSelectedIni(event) {
    if (event.data && event.data.initiative_ID) {
      this.selectedInitiative = event.data;
      this.getFieldData();
    }
  }

  getFieldData(type:string = ''){
    const payload = {
      initiativeID : this.selectedInitiative.initiative_ID,
      activeFlag : 'yes'
    }
    this.maintenanceService.getFieldData(payload).subscribe(res=>{
      if(type){
        if(type == 'Generic')
          this.fieldData['key'] = res['key'];
        if(type == 'Initiative')
          this.fieldData['Calc_initiative'] = res['Calc_initiative'];
        this.fieldData[type] = res[type];
        this.fieldData = {...this.fieldData};
      }else{
        this.fieldData = res;
      }
    });
  }

  refreshData(ev){
    if(ev.message){
      this.getFieldData(ev.type);
    }
  }
}
